import React, { MouseEventHandler, TouchEventHandler } from 'react';
import { type LinkProps } from '@helpers/types';
import { Link as TSRLink, AnyRouter } from '@tanstack/react-router';

const SafeLink = TSRLink as unknown as typeof TSRLink<AnyRouter>;

const Link = ({
  as: _as,
  children,
  className,
  href,
  legacyBehavior: _legacyBehavior,
  locale: _locale,
  onClick,
  onMouseEnter,
  onTouchStart,
  passHref: _passHref,
  prefetch: _prefetch,
  replace: _replace,
  scroll: _scroll,
  shallow: _shallow,
  ...rest
}: Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href' | 'onClick' | 'onMouseEnter' | 'onTouchStart'> &
  LinkProps) => (
  <SafeLink
    to={typeof href === 'string' ? href : href?.pathname || ''}
    search={typeof href === 'string' ? undefined : (href.query as any)}
    onClick={onClick as unknown as MouseEventHandler<HTMLAnchorElement>}
    onMouseEnter={onMouseEnter as unknown as MouseEventHandler<HTMLAnchorElement>}
    onTouchStart={onTouchStart as unknown as TouchEventHandler<HTMLAnchorElement>}
    className={className}
    {...rest}
  >
    {children}
  </SafeLink>
);

export default Link;
